// These were added in Jun 2025, before that tracked clicks did not match this pattern
export const V2_NOTIFICATION_REDIRECT_CLICK_TYPE = {
  // link to program without specifying the tab (This will not scroll down to the tabs content and the user may only see the header if the tabs are not already visible in the screen without scrolling)
  CAMPAIGN_VIEW_PROGRAM: 'campaign_view_program',

  // Link to the program page tab
  CAMPAIGN_ASK_PROGRAM_QUESTION: 'campaign_ask_program_question',
  CAMPAIGN_VIEW_PROGRAM_ABSTRACTS: 'campaign_view_program_abstracts',
  CAMPAIGN_VIEW_PROGRAM_VIDEOS: 'campaign_view_program_videos',

  // Link to specific item in the program page tab
  CAMPAIGN_VIEW_PROGRAM_QUESTION: 'campaign_view_program_question',

  CAMPAIGN_START_CME_PROGRAM: 'campaign_start_cme_program',
}
